export default __webpack_public_path__ + "static/media/KFOlCnqEu92Fr1MmEU9fCxc4AMP6lbBP.c5f3dabc.woff2";